// components
import CommonActionModal from "../Common/CommonActionModal";
import TaskEditPhase from "./TaskEditPhase";

// icons
import EditIcon from '@mui/icons-material/Edit';


class TaskEditPhaseModal extends CommonActionModal {
    async setModalOpenFalse() {
        if (this.props.callBack){
            await this.props.callBack();
        }
        this.setState(
            {
                modalOpen: false,
            }
        );
    }

    componentDidMount(){
        this.setState({
            button:{
                icon: EditIcon,
                iconOnly: true,
            },
            modalLabel: 'Редактирование этапа',
            modalIcon: EditIcon,
            mainComponent: TaskEditPhase,
            mainComponentProps: {
                task: this.props.task,
                callBack: this.setModalOpenFalse.bind(this),
            },
            ready: true,

        })
    }
}

export default TaskEditPhaseModal